import React from "react";

import styles from "./icons.css";

import moreIcon from "./svg/icon-more.svg";
import pinterestIcon from "./svg/icon-pinterest-large.svg";
import infoIcon from "./svg/icon-info.svg";
import settingsIcon from "./svg/icon-settings.svg";
import addIcon from "./svg/icon-add.svg";
import locationIcon from "./svg/icon-location.svg";
import starIconSmall from "./svg/icon-star-small.svg";
import forkIconSmall from "./svg/icon-fork-small.svg";
import favouriteIconSmall from "./svg/icon-favourite-small.svg";
import tickCicleIcon from "./svg/icon-tick-circle.svg";
import tickIconSmall from "./svg/icon-tick-small.svg";

export const PinterestIconLarge = () => <Icon icon={pinterestIcon} />;
export const InfoIcon = () => <Icon icon={infoIcon} />;
export const MoreIcon = () => <Icon icon={moreIcon} />;
export const SettingsIcon = () => <Icon icon={settingsIcon} />;
export const AddIcon = () => <Icon icon={addIcon} />;
export const LocationIcon = () => <Icon icon={locationIcon} />;
export const StarIconSmall = () => <Icon icon={starIconSmall} />;
export const ForkIconSmall = () => <Icon icon={forkIconSmall} />;
export const FavouriteIconSmall = () => <Icon icon={favouriteIconSmall} />;
export const TickCicleIcon = () => <Icon icon={tickCicleIcon} />;
export const TickIconSmall = () => <Icon icon={tickIconSmall} />;

const Icon = ({ icon }) => {
	return (
		<span className={styles.icon} dangerouslySetInnerHTML={{ __html: icon }} />
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/icons/icons.js